import { post } from "../../../../services/request";

export const getUnassignedProviderList = (payload = {}) => {
  return post("Radiologist/GetUnassignedProviders", payload);
};